import { render, staticRenderFns } from "./brainCardiovascularRiskAssessment.vue?vue&type=template&id=e6517b78"
import script from "./brainCardiovascularRiskAssessment.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularRiskAssessment.vue?vue&type=script&lang=js"
import style0 from "./brainCardiovascularRiskAssessment.vue?vue&type=style&index=0&id=e6517b78&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6517b78')) {
      api.createRecord('e6517b78', component.options)
    } else {
      api.reload('e6517b78', component.options)
    }
    module.hot.accept("./brainCardiovascularRiskAssessment.vue?vue&type=template&id=e6517b78", function () {
      api.rerender('e6517b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularRiskAssessment.vue"
export default component.exports